import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { FinancialDelinquentModel } from './types';
import { financialDelinquentItemValidator } from './validators/item';

const financialDelinquentValidator: ValidateJSModel<FinancialDelinquentModel> = {
  HasDelinquent: {
    hasValue: { validator: hasYesOrNo },
  },

  List: (value, attributes) => {
    if (attributes?.HasDelinquent?.value === 'Yes') {
      return {
        presence: true,
        accordion: {
          validator: financialDelinquentItemValidator,
        },
      };
    }

    return {};
  },
};
export default financialDelinquentValidator;
